import React from 'react';
import { useGetAppraisersProfileQuery } from '../../../hooks/useGetAppraisersProfileQuery';
import { AppraisersProfileProvider } from '../contexts/AppraisersProfileContext';

/**
 * @typedef {object} AppraisersProfileDataProviderProps
 * @property {number} eventId
 * @property {React.ReactNode} [children]
 */

/**
 * @param {AppraisersProfileDataProviderProps} props
 */
const AppraisersProfileDataProvider = props => {
  const { children, eventId } = props;

  const appraisersProfile = useGetAppraisersProfileQuery(eventId);

  return (
    <AppraisersProfileProvider value={appraisersProfile}>{children}</AppraisersProfileProvider>
  );
};

export default AppraisersProfileDataProvider;
